import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Modal from "react-modal";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { commonDeleteApi } from "../../../redux/reducers/deleteApiSlice";
import { workoutExercisesDelete } from "../../../data/ApiEndpoints";
import Loader from "../../ui/Loader";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import ExerciseAddForm from "./ExerciseAddForm";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import { BodyBuilder } from "../../../exports/Images";

const AllExercises = ({
  tbDatas,
  isPage,
  setIsPage,
  callFunction,
  userInfoData,
  modValues,
  setModValues,
  onCloseModalvalues,
  isAllExerciseLoading,
}) => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.delApi);

  const { data, pagination } = tbDatas || {};
  const { isModOpen, cardName } = modValues || {};

  const handleDelete = async (filter) => {
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: workoutExercisesDelete,
              queryParams: filter,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(response?.message || "Deleted successfully!");
            callFunction();
          } else {
            toast.error(response?.message || "Can not delete!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete");
        }
      };

      showConfirmAlert(handleConfirm, `Are you sure, you want to delete!`);
    } else {
      toast.error("UID required!");
    }
  };

  const tbColumns = [
    {
      dataField: "wo_name",
      text: "Exercise name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data bold">
            {row?.wo_name?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "category",
      text: "Primary muscle",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.category || "NA"}</span>;
      },
    },
    {
      dataField: "secondary_category",
      text: "Secondary muscle ",
      formatter: (cell, row) => {
        return (
          <span
            className={`tb-data ${
              row?.secondary_category?.length > 0 ? "link" : ""
            }`}
            onClick={() =>
              row?.secondary_category?.length > 0 &&
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardName: "secondary_category",
                alternate: row.secondary_category,
              }))
            }>
            {row?.secondary_category?.length > 0 ? "View" : "NA"}
          </span>
        );
      },
    },
    {
      dataField: "workout_mode",
      text: "workout mode",
      formatter: (cell, row) => {
        return (
          <span className={`tb-data `}>
            {row?.workout_mode?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "equipment_required",
      text: "Equipment required",
      formatter: (cell, row) => {
        return (
          <span
            className={`tb-data ${
              row?.equipment_required?.length > 0 ? "link" : ""
            }`}
            onClick={() =>
              row?.equipment_required?.length > 0 &&
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardName: "equipment_required",
                alternate: row.equipment_required,
              }))
            }>
            {row?.equipment_required?.length > 0 ? "View" : "NA"}
          </span>
        );
      },
    },
    {
      dataField: "tnv_calorie",
      text: "Tentetive calorie",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.tnv_calorie || 0}</span>;
      },
    },
    {
      dataField: "e_duration",
      text: "Tentetive Duration",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.e_duration || 0}</span>;
      },
    },
    {
      dataField: "movement_type",
      text: "movement type",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.movement_type || 0}</span>;
      },
    },
    {
      dataField: "alternate",
      text: "Alternate exercise",
      formatter: (cell, row) => {
        return (
          <span
            className={`tb-data ${row?.alternate?.length > 0 ? "link" : ""}`}
            onClick={() =>
              row?.alternate?.length > 0 &&
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardName: "alternate_exercise",
                alternate: row.alternate,
              }))
            }>
            {row?.alternate?.length > 0 ? "View" : "NA"}
          </span>
        );
      },
    },
    {
      dataField: "image",
      text: "Exercise Icon",
      formatter: (cell, row) => {
        return (
          <div className="tb-img lightBorderRadiusImg">
            <img
              src={row?.image || BodyBuilder}
              alt={row?.wo_name || "NA"}
              className="image"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  viewImage: row?.image || BodyBuilder,
                  cardName: "image",
                }))
              }
            />
          </div>
        );
      },
    },
    {
      dataField: "video",
      text: "Video",
      formatter: (cell, row) => {
        return (
          <div className="tb-play-btn">
            <button
              className="play-btn"
              type="button"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: row?.video ? true : false,
                  viewVideo: row?.video ? row?.video : "",
                  cardName: "video",
                }))
              }
              style={{
                cursor: row?.video ? "pointer" : "not-allowed",
              }}>
              {row?.video ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-play-circle"
                  viewBox="0 0 16 16"
                  style={{ color: "rgb(52, 116, 241)" }}>
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                  <path d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445" />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-ban"
                  viewBox="0 0 16 16"
                  style={{ color: "#787878" }}>
                  <path d="M15 8a6.97 6.97 0 0 0-1.71-4.584l-9.874 9.875A7 7 0 0 0 15 8M2.71 12.584l9.874-9.875a7 7 0 0 0-9.874 9.874ZM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0" />
                </svg>
              )}
            </button>
          </div>
        );
      },
    },
    {
      dataField: "thumbnail",
      text: "Exercise Image",
      formatter: (cell, row) => {
        return (
          <div className="tb-img lightBorderRadiusImg">
            <img
              src={row?.thumbnail || BodyBuilder}
              alt={row?.wo_name || "NA"}
              className="image"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  viewImage: row?.thumbnail || BodyBuilder,
                  cardName: "image",
                }))
              }
            />
          </div>
        );
      },
    },
    {
      dataField: "status",
      text: "status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius27"
            style={{
              background: row?.status === "active" ? "#E2EFD5" : "#F3DADA",
              color: row?.status === "active" ? "#379C00" : "#D90000",
            }}>
            {row?.status || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn icon edit"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                rowData: row,
                cardName: "edit",
              }))
            }>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-pencil-fill"
              viewBox="0 0 16 16">
              <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
            </svg>
          </button>

          <button
            className="actionBtn icon delete"
            onClick={() => {
              const uidFilter = {
                uid: row?.uid || "",
              };
              handleDelete(uidFilter);
            }}>
            {loading ? (
              <Loader />
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-trash3-fill"
                viewBox="0 0 16 16">
                <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
              </svg>
            )}
          </button>
        </div>
      ),
    },
  ];

  const alternateTbColumns = [
    {
      dataField: "wo_name",
      text: "Exercise name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.wo_name?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "category_name",
      text: "Primary muscle",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.category_name || "NA"}</span>;
      },
    },
  ];

  const secondaryEquipmentsTbColumns = [
    {
      dataField: "name",
      text: "Name",
      formatter: (cell, row) => {
        return <span className="tb-data">{row?.name || "NA"}</span>;
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={isModOpen}
        onRequestClose={onCloseModalvalues}
        contentLabel="Add Exercise Modal"
        ariaHideApp={false}>
        {cardName === "add" || cardName === "edit" ? (
          <ExerciseAddForm
            userInfoData={userInfoData}
            callFunction={callFunction}
            closeModal={onCloseModalvalues}
            isEdit={cardName === "edit"}
            rowData={modValues.rowData}
          />
        ) : (
          <div
            className={`createNewCTOModalContainer`}
            style={{
              width:
                cardName === "image" ||
                cardName === "video" ||
                cardName === "alternate_exercise" ||
                cardName === "secondary_category" ||
                cardName === "equipment_required"
                  ? "auto"
                  : "",
              height:
                cardName === "image" || cardName === "video" ? "auto" : "",
            }}>
            {cardName !== "add" && cardName !== "edit" ? (
              <ModalHeadAndClose
                title={`${cardName?.replace(/_/g, " ")}`}
                onClose={onCloseModalvalues}
              />
            ) : null}

            {cardName === "alternate_exercise" ||
            cardName === "secondary_category" ||
            cardName === "equipment_required" ? (
              <div className="fullWidthFlexCenter overflowAuto separatedTable">
                <PaymentLinkTable
                  tableData={modValues.alternate}
                  tableColumns={
                    cardName === "secondary_category" ||
                    cardName === "equipment_required"
                      ? secondaryEquipmentsTbColumns
                      : alternateTbColumns
                  }
                />
              </div>
            ) : cardName === "image" ? (
              <div className="discussionModalMessage mt30">
                <img
                  src={modValues.viewImage}
                  alt="profile"
                  style={{
                    width: "400px",
                    height: "400px",
                  }}
                />
              </div>
            ) : cardName === "video" ? (
              <div className="discussionModalMessage mt30">
                <video width="320" height="240" controls>
                  <source src={modValues.viewVideo}></source>
                </video>
              </div>
            ) : null}
          </div>
        )}
      </Modal>

      <div className="fullWidthFlexCenter overflowAuto separatedTable">
        {isAllExerciseLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={Array.isArray(data) && data.length > 0 ? data : []}
            tableColumns={Array.isArray(tbColumns) ? tbColumns : []}
            tablePagination={
              Array.isArray(pagination) && pagination.length > 0
                ? pagination
                : []
            }
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
          />
        )}
      </div>
    </>
  );
};

export default AllExercises;
